import React, { useCallback, useEffect, useState } from 'react';
import { Input, Button, Typography, DatePicker, Image, Result, TimePicker, Switch, Tooltip } from 'antd'
import { useScreenSize } from '../../../hooks/useScreenSize';
import { apiGetEvent, apiUpdateEvent, apiUploadEventMessage, apiUploadEventPhoto, apiCancelEvent } from '../../../utils/api';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/es_ES';
import { LocationEvent } from './LocationEvent';
import { UploadOutlined, CloseOutlined } from '@ant-design/icons';
import { prMain } from '../../../themeConfig';
import { CreateMessages } from './CreateMessages';
import { openMessage } from '../Utils/MessageDisplay';

const DetailsEvent = ({ data, setOpenDetails, refresh, setRefresh }) => {
    const { Text } = Typography
    const { height } = useScreenSize()
    const [loading, setloading] = useState(false)
    const [dateEvent, setDateEvent] = useState(data.startTime ? moment(data.startTime).format() : moment().format())
    const [finalDateEvent, setFinalDateEvent] = useState(data.endTime ? moment(data.endTime).format() : moment().format())

    const [checkedAt, setCheckedAt] = useState(data.checkedAt ? moment(data.checkedAt).format() : moment().format())
    const [startTime, setStartTime] = useState(data.startTime ? moment(data.startTime).format() : moment().format())
    const [endTime, setEndTime] = useState(data.endTime ? moment(data.endTime).format() : moment().format())
    const [step, setStep] = useState(0)
    const [values, setValues] = useState(data ? data : [])
    const [location, setLocation] = useState((data.latitude && data.longitude) ? { latitude: data.latitude, longitude: data.longitude, address: data.address } : [])
    const [success, setSuccess] = useState(false)
    const [urlImg, setUrlImg] = useState(data.photo ? data.photo : "")

    const [imageChanged, setimageChanged] = useState(false)
    const [messageImg, setMessageImg] = useState(null)
    const [urlMessageImg, seturlMessageImg] = useState(data.footImage ? data.footImage : "")
    const [qrRequired, setqrRequired] = useState(data.qrRequired)

    const [notification, setNotification] = useState(true)


    const handleSubmit = () => {
        if (!values.eventName || !values.description || !values.place || !startTime || !endTime || !checkedAt) return

        let data = {
            "eventName": values.eventName,
            "description": values.description,
            "place": values.place,
            "startTime": `${moment(startTime).format().toString().slice(0, -6)}`,
            "endTime": `${moment(endTime).format().toString().slice(0, -6)}`,
            "address": location.address,
            "latitude": location.latitude,
            "longitude": location.longitude,
            "checkedAt": `${moment(checkedAt).format().toString().slice(0, -6)}`,
            "qrRequired": qrRequired
        }

        if (!imageChanged) {
            data = { ...data, title: values.title, message: values.message, footImage: urlMessageImg }
        }
 
        setloading(true)
        apiUpdateEvent(values.idEvent, data, notification).then((response) => {
            if (imageChanged) {

                apiUploadEventMessage(response.data.idEvent, messageImg, values.title, values.message).then(res => {
                    console.log(res)
                    setimageChanged(false)
                }).catch(err => {
                    new Error(err)
                })
            }
            setSuccess(true)
            setStep(2)
            setRefresh(!refresh)
            getEvent()

        }).catch(error => {
            setSuccess(false)
            setStep(2)
        }).finally(() => {
            setloading(false)
        })

    }

    const handleMessageImage = (e) => {

        if (!e) return

        setimageChanged(true)
        setMessageImg(e.target.files[0])
        seturlMessageImg(URL.createObjectURL(e.target.files[0]))

    }

    const handleRemoveMessageImg = (name) => {

        document.getElementById(name).value = "";

        setMessageImg(null)
        seturlMessageImg("")
    }

    const handleChange = (event, key) => {
        setValues({ ...values, [key]: event.target.value })
    }


    const handleImage = (e) => {

        if (!e) return

        apiUploadEventPhoto(values.idEvent, e.target.files[0]).then(() => {
            // setstateImg(e.target.files[0])
            setUrlImg(URL.createObjectURL(e.target.files[0]))
            setRefresh(prev => !prev)
            openMessage({ type: 'success', message: `Imagen Actualizada Con Éxito` })
            getEvent()
        }).catch(err => {
            setSuccess(false)
            new Error(err)
        })

    }

    const isReadyToUpdate = () => {

        if (values.eventName !== data.eventName ||
            values.description !== data.description ||
            values.place !== data.place ||
            values.title !== data.title ||
            imageChanged ||
            values.message !== data.message ||
            !moment(startTime.toString()).isSame(moment(data.startTime)) ||
            !moment(endTime.toString()).isSame(moment(data.endTime)) ||
            !moment(checkedAt.toString()).isSame(moment(data.checkedAt)) ||
            location.latitude !== data.latitude ||
            location.longitude !== data.longitude ||
            location.address !== data.address ||
            qrRequired !== data.qrRequired
        ) {
            return true
        }

        return false
    }

    const getEvent = useCallback(() => {
        apiGetEvent(data.idEvent).then(res => {
            setValues(res.data)

            setUrlImg(res.data.photo)
            seturlMessageImg(res.data.footImage)

            setDateEvent(moment(res.data.startTime))
            setFinalDateEvent(moment(res.data.endTime))
            setStartTime(moment(res.data.startTime))
            setEndTime(moment(res.data.endTime))
            setCheckedAt(moment(res.data.checkedAt))

            setLocation(prev => ({ ...prev, latitude: res.data.latitude, longitude: res.data.longitude, address: res.data.address }))
        }).catch(err => {
            new Error(err)
        })
    }, [])

    useEffect(() => {
        getEvent()
    }, [getEvent])

    const onChangeSwitch = (e) => {
        setqrRequired(e)
    }

    const handleSetDateEvent = (event) => {

        setDateEvent(event)

        handleSetStartTime(event, event)
        handleSetCheckin(event, new Date(moment(event).subtract(1, 'hour').format()))
    }
    const handleSetFinalDateEvent = (event) => {

        setFinalDateEvent(event)
        handleSetEndTime(event, new Date(moment(event).add(1, 'hour').format()))
    }

    const handleSetStartTime = (date, hr) => {
        let hour = moment(hr).format('LTS').toString().length < 8 ? `0${moment(hr).format('LTS').toString()}` : moment(hr).format('LTS').toString()
        setStartTime(new Date(`${moment(date).format('YYYY-MM-DD')}T${hour}`))
    }

    const handleSetEndTime = (date, hr) => {
        let hour = moment(hr).format('LTS').toString().length < 8 ? `0${moment(hr).format('LTS').toString()}` : moment(hr).format('LTS').toString()
        setEndTime(new Date(`${moment(date).format('YYYY-MM-DD')}T${hour}`))
    }

    const handleSetCheckin = (date, hr) => {
        let hour = moment(hr).format('LTS').toString().length < 8 ? `0${moment(hr).format('LTS').toString()}` : moment(hr).format('LTS').toString()
        setCheckedAt(new Date(`${moment(date).format('YYYY-MM-DD')}T${hour}`))
    }

    const cancelEvent = () => {
        apiCancelEvent(values.idEvent).then((response) => {
            setSuccess(true)
            setStep(5)
        }).catch((e) => {
            console.log(e)
            setSuccess(false)
            setStep(5)
        })
    }

    const changeNotification = (e) => {
        setNotification(e)
    }

    return (
        <div style={{ width: '100%' }}>
            <div style={classes.a}>
                {
                    step !== 2 &&
                    <>
                        <div></div>
                        <Text style={{ fontSize: '1.5rem' }}>Detalles del Evento</Text>
                        <CloseOutlined onClick={() => setOpenDetails(false)} />
                    </>
                }
            </div>
            {
                step === 0 &&
                <div style={{ width: '100%' }}>
                    <section style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                        <section style={{ width: '100%', display: 'flex', gap: '3rem' }}>
                            <div style={{ justifyContent: 'center' }}>
                                <label style={{ backgroundColor: prMain }} className='input-container' >
                                    <UploadOutlined style={{ marginRight: 10 }} />
                                    <input
                                        id={'eventImageInput'}
                                        className='inputSelect'
                                        type="file"
                                        onChange={handleImage}
                                    />
                                    {urlImg ? 'Cambiar Imagen' : `Seleccionar Imagen (Opcional)`}
                                </label>
                                <div style={{ height: 'fit-content', maxHeight: 350, width: 250, display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 15, position: 'relative' }}>
                                    {
                                        urlImg
                                            ?
                                            <>
                                                <Image id={'eventImage'} src={urlImg} alt={'Imagen del evento'} height={350} style={{ objectFit: 'cover' }} />
                                                {/* <Button icon={<DeleteFilled />} type='link' onClick={() => handleRemoveImage()}>Remover</Button> */}
                                            </>
                                            :
                                            <Image
                                                style={{ objectFit: 'cover' }}
                                                width={'100%'}
                                                height={350}
                                                src="error"
                                                fallback="data:image/png;base64,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"
                                            />
                                    }
                                </div>
                            </div>


                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '1rem' }}>

                                    <div style={{ position: 'relative', }}>
                                        <label style={{ fontSize: '1rem', opacity: 0.6 }}>Boleto Digital</label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                            <Switch checked={qrRequired} onChange={onChangeSwitch} />
                                            {
                                                qrRequired ? (
                                                    <div>
                                                        Si
                                                    </div>
                                                ) : (
                                                    <div>
                                                        No
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <Tooltip title="Solo al cambiar fecha o ubicación">
                                        <div style={{ position: 'relative', }}>
                                            <label style={{ fontSize: '1rem', opacity: 0.6 }}>Enviar notificación</label>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'center' }}>

                                                <Switch checked={notification} onChange={changeNotification} />
                                                {
                                                    notification ? (
                                                        <div>
                                                            Si
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            No
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </Tooltip>

                                </div>
                                <div style={{ display: 'flex', gap: '1.5rem', flexDirection: height > 600 ? 'column' : 'row' }}>
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <label style={{ fontSize: '1rem', opacity: 0.6 }}>Nombre del evento *</label>
                                        <Input
                                            id='eventName'
                                            name='eventName'
                                            onChange={(e) => handleChange(e, "eventName")}
                                            value={values.eventName}
                                            style={{ height: 40 }}
                                            size='large'
                                            placeholder='Ingrese el nombre del evento'
                                        />
                                    </div>
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <label style={{ fontSize: '1rem', opacity: 0.6 }}>Descripción *</label>
                                        <Input.TextArea
                                            id='description'
                                            name='description'
                                            onChange={(e) => handleChange(e, "description")}
                                            value={values.description}
                                            style={{ height: 80, resize: 'none' }}
                                            size='large'
                                            placeholder='Ingrese la descripción del evento'
                                        />
                                    </div>
                                </div>
                                <div style={{ position: 'relative', marginTop: '1.5rem' }}>
                                    <label style={{ fontSize: '1rem', opacity: 0.6 }}>Lugar *</label>

                                    <Input
                                        id='place'
                                        name='place'
                                        onChange={(e) => handleChange(e, "place")}
                                        value={values.place}
                                        style={{ height: 40 }}
                                        size='large'
                                        max={10}
                                        placeholder='Ingrese el lugar'
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '1rem', marginTop: '1.5rem' }}>
                                    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                                        <label style={{ fontSize: '1rem', opacity: 0.6 }}>Fecha y hora inicial* </label>
                                        <div style={{ display: 'flex', WebkitFlexDirection: 'column', gap: '1rem' }}>
                                            <DatePicker
                                                id="dateEvent"
                                                name="dateEvent"
                                                format='DD-MM-YYYY'
                                                allowClear={false}
                                                locale={locale}
                                                value={moment(dateEvent)}
                                                onChange={(e) => handleSetDateEvent(e)}
                                            />
                                            <div style={{ display: 'flex', WebkitFlexDirection: 'row', gap: '1rem' }}>
                                                <Tooltip title="Inicio del evento">

                                                    <TimePicker
                                                        allowClear={false}
                                                        format='HH:mm'
                                                        id='startTime'
                                                        name='startTime'
                                                        locale={locale}
                                                        value={moment(startTime)}
                                                        onChange={(e) => handleSetStartTime(dateEvent, e)}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <label style={{ fontSize: '1rem', opacity: 0.6 }}>Fecha y hora final* </label>
                                        <div style={{ display: 'flex', WebkitFlexDirection: 'column', gap: '1rem' }}>
                                            <DatePicker
                                                id="dateEvent"
                                                name="dateEvent"
                                                format='DD-MM-YYYY'
                                                allowClear={false}
                                                locale={locale}
                                                value={moment(finalDateEvent)}
                                                onChange={(e) => handleSetFinalDateEvent(e)}
                                            />
                                            <div style={{ display: 'flex', WebkitFlexDirection: 'row', gap: '1rem' }}>
                                                <Tooltip title="Fin del evento">

                                                    <TimePicker
                                                        allowClear={false}
                                                        format='HH:mm'
                                                        id='endTime'
                                                        name='endTime'
                                                        locale={locale}
                                                        value={moment(endTime)}
                                                        onChange={(e) => handleSetEndTime(dateEvent, e)}
                                                    />
                                                </Tooltip>

                                            </div>
                                        </div>
                                        {/* {(startTime > endTime) &&
                                            <div style={{ width: '250px', display: 'flex', justifyContent: 'center' }}>
                                                <label style={{ fontSize: '0.6rem', opacity: 0.6, textAlign: 'center', color: 'red' }}>
                                                    { moment(startTime).format() < moment().format() ?
                                                     'Evento cancelado. Para activarlo, actualice a una fecha posterior a hoy' :
                                                     'Las horas no están en el orden correcto'
                                                    }
                                                </label>
                                            </div>
                                        } */}
                                        {(moment(startTime).format() < moment().format()) ?
                                            <div style={{ width: '250px', display: 'flex', justifyContent: 'center' }}>
                                                <label style={{ fontSize: '0.6rem', opacity: 0.6, textAlign: 'center', color: 'red' }}>
                                                    Evento cancelado o concluido. Para activarlo nuevamente, actualice a una fecha posterior a hoy
                                                </label>
                                            </div>
                                            : (startTime > endTime) &&
                                            <div style={{ width: '250px', display: 'flex', justifyContent: 'center' }}>
                                                <label style={{ fontSize: '0.6rem', opacity: 0.6, textAlign: 'center', color: 'red' }}>
                                                    Las horas no están en el orden correcto
                                                </label>
                                            </div>

                                        }
                                    </div>
                                    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                                        <label style={{ fontSize: '1rem', opacity: 0.6 }}>Inicio de Check-in *</label>
                                        <TimePicker
                                            allowClear={false}
                                            id='checkin'
                                            name='checkin'
                                            format='HH:mm'
                                            locale={locale}
                                            value={moment(checkedAt)}
                                            onChange={(e) => handleSetCheckin(dateEvent, e)}
                                        />
                                        {(checkedAt > endTime) &&
                                            <div style={{ width: '120px', display: 'flex', justifyContent: 'center' }}>
                                                <label style={{ fontSize: '0.6rem', opacity: 0.6, textAlign: 'center', color: 'red' }}>
                                                    Check-in está después del final del evento
                                                </label>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                        </section>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>

                            <Button type='link' style={{ display: 'flex', justifyContent: 'left' }} onClick={() => setStep(4)}
                                disabled={moment(startTime).format() < moment().format()}
                            >
                                Cancelar evento
                            </Button>
                            <Button

                                type='link' onClick={() => setStep(3)}>
                                Mensajes de Resultado
                            </Button>
                            <Button

                                type='link' onClick={() => setStep(1)}>
                                Ubicación del Evento
                            </Button>
                            <Button type='primary' onClick={handleSubmit}
                                loading={loading}
                                disabled={
                                    !isReadyToUpdate() ||
                                    !values.eventName ||
                                    !values.description ||
                                    !values.place ||
                                    !values.title ||
                                    !values.message ||
                                    !startTime ||
                                    !endTime ||
                                    (startTime > endTime) ||
                                    (checkedAt > endTime) ||
                                    !checkedAt
                                }
                            >
                                Actualizar
                            </Button>

                        </div>
                    </section>
                </div>
            }
            {
                step === 1 &&
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <LocationEvent setLocation={setLocation} location={location} />

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>

                        <Button

                            type='link' onClick={() => setStep(3)}>
                            Mensajes de Resultado
                        </Button>
                        <Button type='link' onClick={() => { setStep(0) }}>
                            Información General
                        </Button>
                        <Button
                            loading={loading}
                            disabled={
                                location.length === 0 ||
                                !isReadyToUpdate() ||
                                !values.eventName ||
                                !values.description ||
                                !values.place ||
                                !values.title ||
                                !values.message ||
                                !startTime ||
                                !endTime ||
                                !checkedAt
                            }
                            type='primary'
                            onClick={handleSubmit}
                        >
                            Actualizar
                        </Button>
                    </div>
                </div>
            }
            {
                step === 3 &&
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <CreateMessages isDetails values={values} setvalues={setValues} handleChange={handleChange} handleImage={handleMessageImage} handleRemoveImage={handleRemoveMessageImg} urlImg={urlMessageImg} />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                        <Button type='link' onClick={() => { setStep(0) }}>
                            Información General
                        </Button>
                        <Button type='link' onClick={() => { setStep(1) }}>
                            Lugar del Evento
                        </Button>
                        <Button
                            loading={loading}
                            disabled={
                                location.length === 0 ||
                                !isReadyToUpdate() ||
                                !values.eventName ||
                                !values.description ||
                                !values.place ||
                                !values.title ||
                                !values.message ||
                                !startTime ||
                                !endTime ||
                                !checkedAt
                            }
                            type='primary'
                            onClick={handleSubmit}
                        >
                            Actualizar
                        </Button>
                    </div>
                </div>
            }
            {
                step === 2 &&
                (
                    success
                        ?
                        <Result
                            status='success'
                            title='Evento Actualizado'
                            subTitle={'El evento ha sido actualizado exitosamente'}
                            extra={[
                                <Button key='ok' type='primary' onClick={() => setOpenDetails(false)} autoFocus >
                                    Aceptar
                                </Button>
                            ]}
                        />
                        :
                        <Result
                            status='error'
                            title='Error en la petición'
                            subTitle={"Se ha producido un error en la petición. Por favor, intente nuevamente."}
                            extra={[
                                <Button style={{ marginTop: 15 }} key='exit' type='primary' onClick={() => setOpenDetails(false)} autoFocus >
                                    Salir
                                </Button>
                            ]}
                        />
                )
            }
            {
                step === 4 &&
                <Result
                    status='info'
                    title='Cancelar Evento'
                    subTitle='¿Está seguro que desea cancelar este evento?'
                    extra={[
                        <div>
                            <Button type='link' onClick={() => setStep(0)}>
                                Volver
                            </Button>
                            <Button type='primary' onClick={() => cancelEvent()}>
                                Aceptar
                            </Button>
                        </div>
                    ]}
                />
            }
            {
                step === 5 &&
                (
                    success
                        ?
                        <Result
                            status='success'
                            title='Evento Cancelado'
                            subTitle={'El evento ha sido cancelado exitosamente'}
                            extra={[
                                <Button key='ok' type='primary' onClick={() => setOpenDetails(false)} autoFocus >
                                    Aceptar
                                </Button>
                            ]}
                        />
                        :
                        <Result
                            status='error'
                            title='Error en la petición'
                            subTitle={"Se ha producido un error en la petición. Por favor, intente nuevamente."}
                            extra={[
                                <Button style={{ marginTop: 15 }} key='exit' type='primary' onClick={() => setOpenDetails(false)} autoFocus >
                                    Salir
                                </Button>
                            ]}
                        />
                )
            }
        </div >

    );
}

const classes = {
    button: {
        textTransform: 'capitalize',
        width: '50%',
        height: '50px',
        fontSize: '15px',
        fontWeight: 'bold',
    },
    root: {
        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)',
        height: 'auto',
        overflowY: 'auto',
        background: '#fafafa',
        borderRadius: '3%',
        display: 'flex',
        flexDirection: 'flex',
        justifyContent: 'center',
        padding: '20px',
        margin: '10%'
    },
    logo: {
        width: 100,
    },
    buttons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        '& > *': {
        },
    },
    a: {
        display: 'flex',
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 20
    },
    btnFacebook: {
        display: 'flex',
        justifyContent: 'space-evenly',
        '& > *': {
        },
    },
}

export default DetailsEvent

